import Header from 'components/Header';
import ScreenVideo from 'componentsFor3D/ScreenVideo';
import Configurator from 'layout/Configurator';
import Elements from 'layout/Elements';
import Home from 'layout/Home';
import { ControlContext } from 'provider/ControlProvider';
import { useContext } from 'react';

function App() {
  const { controlStatus } = useContext(ControlContext);
  return (
    <>
      <Configurator />
      <Elements />
      <Header />
      <ScreenVideo />
      {!controlStatus && <Home />}
    </>
  );
}

export default App;
